//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'success',
  data() {
    return {
      buttons: [],
      back_home_link: '',
      detail_link: ''
    }
  },
  methods: {
    backHomeClick() {
      this.$router.replace(this.back_home_link)
    },
    seeDetailClick() {
      this.$router.replace(this.detail_link)
    }
  },
  created() {
    this.back_home_link = '/maternal_service?id=' + this.$route.query.id +'&tabVal=' + this.$route.query.tabVal

    let name = this.$route.query.name
    console.log(name)
    switch (name) {
      case 'month_live':
        this.detail_link = '/month_live?id=' + this.$route.query.id +'&tabVal=' + this.$route.query.tabVal
        break
      case 'add_from_record':
        this.detail_link =
          '/check_room_service?id=' +
          this.$route.query.id +
          '&form_id=' +
          this.$route.query.form_id+
          '&tabVal=' +
          this.$route.query.tabVal
        break
      case 'detail_other_form':
        this.detail_link =
          'detail_other_form?answer_id=' +
          this.$route.query.answer_id +
          '&form_id='+
          this.$route.query.form_id +
          '&id='+
          this.$route.query.id+
          '&tabVal=' +
          this.$route.query.tabVal
        break
      case 'baby_live':
        this.detail_link =
          '/baby_live?id=' +
          this.$route.query.id +
          '&child_id=' +
          this.$route.query.child_id+
          '&tabVal=' +
          this.$route.query.tabVal
        break
      case 'other_form_detail':
        this.detail_link =
          '/other_form_detail?id=' +
          this.$route.query.id +
          '&tabVal=' +
          this.$route.query.tabVal+
          '&form_id=' +
          this.$route.query.form_id 
        break
      // case 'bb_form_a':
      // this.detail_link = './bb_form?a=2'
      case 'bb_form_f':
        this.detail_link =
          '/check_room_service?id=' +
          this.$route.query.id +
          '&form_id=' +
          this.$route.query.form_id+
          '&tabVal=' +
          this.$route.query.tabVal
        break
      case 'bb_form_b':
        this.detail_link =
          '/check_room_service?id=' +
          this.$route.query.id +
          '&form_id=' +
          this.$route.query.form_id+
          '&tabVal=' +
          this.$route.query.tabVal
        break
      case 'bb_form_c':
        this.detail_link =
          '/check_room_service?id=' +
          this.$route.query.id +
          '&form_id=' +
          this.$route.query.form_id+
          '&tabVal=' +
          this.$route.query.tabVal
        break
      case 'bb_form_a':
        this.detail_link =
          '/check_room_service?id=' +
          this.$route.query.id +
          '&form_id=' +
          this.$route.query.form_id+
          '&tabVal=' +
          this.$route.query.tabVal
        break
      case 'maternal_form_b':
        this.detail_link =
          '/check_room_service?id=' +
          this.$route.query.id +
          '&form_id=' +
          this.$route.query.form_id+
          '&tabVal=' +
          this.$route.query.tabVal
        break
      case 'maternal_form_c':
        this.detail_link =
          '/check_room_service?id=' +
          this.$route.query.id +
          '&form_id=' +
          this.$route.query.form_id+
          '&tabVal=' +
          this.$route.query.tabVal
        break
      case 'maternal_form_d':
        this.detail_link =
          '/check_room_service?id=' +
          this.$route.query.id +
          '&form_id=' +
          this.$route.query.form_id+
          '&tabVal=' +
          this.$route.query.tabVal
      break
      case 'maternal_form_a':
        this.detail_link = './maternal_form_a_detail?id='+this.$route.query.id+'&form_id='+this.$route.query.form_id+'&tabVal=' + this.$route.query.tabVal
      break
      case 'maternal_form_a_edit':
        this.detail_link = './maternal_form_a_detail?id='+this.$route.query.id+'&form_id='+this.$route.query.form_id+'&tabVal=' + this.$route.query.tabVal
      break
      case 'bb_form_e':
        this.detail_link = '/bb_form_e_detail?id='+this.$route.query.id+'&form_id='+this.$route.query.form_id+'&child_id='+this.$route.query.child_id+'&tabVal=' + this.$route.query.tabVal
      break
      case 'bb_form_e_edit':
        this.detail_link = '/bb_form_e_detail?id='+this.$route.query.id+'&form_id='+this.$route.query.form_id+'&child_id='+this.$route.query.child_id+'&tabVal=' + this.$route.query.tabVal
      break
      case 'bb_form_d':
        this.detail_link = '/bb_form_d_detail?id='+this.$route.query.id+'&form_id='+this.$route.query.form_id+'&child_id='+this.$route.query.child_id+'&tabVal=' + this.$route.query.tabVal
      break
       case 'bb_form_d_edit':
        this.detail_link = '/bb_form_d_detail?id='+this.$route.query.id+'&form_id='+this.$route.query.form_id+'&child_id='+this.$route.query.child_id+'&tabVal=' + this.$route.query.tabVal
      break
      case 'christmas_form_one':
        this.detail_link = '/check_room_service?id='+this.$route.query.id+'&form_id='+this.$route.query.form_id+'&tabVal=' + this.$route.query.tabVal
      break
      case 'christmas_form_two':
        this.detail_link = '/check_room_service?id='+this.$route.query.id+'&form_id='+this.$route.query.form_id+'&tabVal=' + this.$route.query.tabVal
      break
      case 'christmas_form_three':
        this.detail_link = '/check_room_service?id='+this.$route.query.id+'&form_id='+this.$route.query.form_id+'&tabVal=' + this.$route.query.tabVal
      break
      case 'christmas_form_four':
        this.detail_link = '/check_room_service?id='+this.$route.query.id+'&form_id='+this.$route.query.form_id+'&tabVal=' + this.$route.query.tabVal
      break
      case 'christmas_form_six':
        this.detail_link = '/christmas_form_six_detail?id='+this.$route.query.id+'&tabVal=' + this.$route.query.tabVal
      break
      case 'christmas_form_six_edit':
        this.detail_link = '/christmas_form_six_detail?id='+this.$route.query.id+'&tabVal=' + this.$route.query.tabVal
      break
      case 'christmas_form_seven':
        this.detail_link = '/christmas_form_seven_detail?id='+this.$route.query.id+'&tabVal=' + this.$route.query.tabVal
      break
      case 'christmas_form_seven_edit':
        this.detail_link = '/christmas_form_seven_detail?id='+this.$route.query.id+'&tabVal=' + this.$route.query.tabVal
      break
      case 'christmas_form_eight':
        this.detail_link = '/christmas_form_eight_detail?id='+this.$route.query.id+'&child_id='+this.$route.query.child_id+'&tabVal=' + this.$route.query.tabVal
      break
      case 'christmas_form_eight_edit':
        this.detail_link = '/christmas_form_eight_detail?id='+this.$route.query.id+'&child_id='+this.$route.query.child_id+'&tabVal=' + this.$route.query.tabVal
      break
      case 'medicine_commissioned':
        this.detail_link =
          '/check_room_service?id=' +
          this.$route.query.id +
          '&form_id=' +
          this.$route.query.form_id+
          '&tabVal=' +
          this.$route.query.tabVal
        break
      case 'basic_nursing':
        this.detail_link =
          '/check_room_service?id=' +
          this.$route.query.id +
          '&form_id=' +
          this.$route.query.form_id+
          '&tabVal=' +
          this.$route.query.tabVal
        break
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/success.vue